module.exports = __webpack_public_path__ + "img/advantage_1.31d0ed59.png";